import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { conflictMessages } from "../utils/equipmentConflicts";

// ADO #334. Blocks submission of an agreement whose equipment repeats a serial number or reuses
// one another agreement already covers. Deliberately not a warning to click past: the only way
// forward for a dealer is back to the equipment. An admin may also submit anyway, which the
// submit Lambda accepts only from an admin and records on the agreement.
//
// Escape and backdrop clicks are ignored, as in every other dialog in this flow.
const EquipmentConflictDialog = ({ conflict, canOverride = false, onBack, onOverride }) => {
  const handleClose = (event, reason) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    onBack();
  };

  return (
    <Dialog
      open={Boolean(conflict)}
      onClose={handleClose}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, padding: 1, width: 520 } }}
    >
      <DialogTitle sx={{ fontWeight: 600, fontSize: "1.5rem", pb: 1 }}>
        This agreement can't be submitted
      </DialogTitle>
      <DialogContent dividers>
        {conflictMessages(conflict || {}).map((message) => (
          <Typography key={message} sx={{ mb: 2, fontSize: "1rem" }}>
            {message}
          </Typography>
        ))}
        {conflict?.overrideRefused && (
          <Typography sx={{ fontSize: "1rem", color: "error.main" }}>
            Your override was not applied: the server did not recognise you as an admin. Contact
            JB Warranties support.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        {canOverride && !conflict?.overrideRefused && (
          <Button
            color="error"
            onClick={onOverride}
            sx={{ minWidth: 100, textTransform: "none" }}
          >
            Submit anyway
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={onBack}
          sx={{ minWidth: 120, textTransform: "none", fontWeight: 600 }}
        >
          Back to equipment
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EquipmentConflictDialog;
